import { defineMessage } from 'services/localization';

export const messages = {
    trialOfAllFeatures: defineMessage('trial_of_all_features_f_pire_in_expirydays_days'),
    trialOfAllFeaturesMultiple: defineMessage('trial_of_all_features_f_pire_in_expirydays_days_1'),
    linkText: defineMessage('contact_sales_1'),
    seePricing: defineMessage('see_pricing'),
    hide: defineMessage('hide'),
};
